import { FC, MouseEvent } from 'react';
import styled from 'styled-components';

import { ReactComponent as HyperlinkIcon } from '@/assets/icons/hyperlink.svg';

const HyperLink = styled('a').attrs({
  rel: 'noreferrer noopener',
  target: '_blank',
})`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  svg {
    margin-right: 6px;
    width: 14px;
    flex-shrink: 0;
  }
  > span {
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
`;

interface Props {
  link: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  title?: string;
}

const GoToLink: FC<Props> = ({ link, onClick, title = 'Go to link' }) => {
  return (
    <HyperLink href={link} onClick={onClick}>
      <HyperlinkIcon />
      <span>{title}</span>
    </HyperLink>
  );
};

export default GoToLink;
